<template>
    <div class="login-page">
        <div class="login-container">
            <!-- 背景图片 -->
            <div class="background-image" v-if="loginBgPath" :style="{ backgroundImage: `url(${loginBgPath})` }"></div>
            <!-- 中央内容面板 -->
            <div class="login-content" v-if="roleLoginTextsImg.bidder == ''">
                <!-- 投标人登录 -->
                <div class="role-bg" :style="roleBgStyle" @click="handleLogin('bidder')">
                    <img :src="tbImgPath" />
                    <div class="role-bg-text" v-if="roleLoginTextsImg.bidder == ''">
                        {{ roleLoginTexts.bidder }}
                    </div>
                </div>
                <!-- 招标人登录 -->
                <div class="role-bg" :style="roleBgStyle" @click="handleLogin('tenderee')">
                    <img :src="zbImgPath" />
                    <div class="role-bg-text" v-if="roleLoginTextsImg.tenderee == ''">
                        {{ roleLoginTexts.tenderee }}
                    </div>
                </div>
                <!-- 招标代理登录 -->
                <div class="role-bg" :style="roleBgStyle" @click="handleLogin('agent')">
                    <img :src="dlImgPath" />
                    <div class="role-bg-text" v-if="roleLoginTextsImg.agent == ''">
                        {{ roleLoginTexts.agent }}
                    </div>
                </div>
                <!-- 评标系统 -->
                <div class="role-bg" :style="roleBgStyle" @click="handleLogin('evaluation')">
                    <img :src="zjImgPath" />
                    <div class="role-bg-text" v-if="roleLoginTextsImg.evaluation == ''">
                        {{ roleLoginTexts.evaluation }}
                    </div>
                </div>
            </div>
            <div v-else class="login-content-img">
                <div class="login-grid">
                    <!-- 投标人登录 -->
                    <div class="role-grid-item" @click="handleLogin('bidder')">
                        <div class="role-icon">
                            <img :src="tbImgPath" />
                        </div>
                        <div class="role-name">
                            <img :src="roleLoginTextsImg.bidder" class="role-name-img" />
                        </div>
                    </div>
                    <!-- 招标人登录 -->
                    <div class="role-grid-item" @click="handleLogin('tenderee')">
                        <div class="role-icon">
                            <img :src="zbImgPath" />
                        </div>
                        <div class="role-name">
                            <img :src="roleLoginTextsImg.tenderee" class="role-name-img" />
                        </div>
                    </div>
                    <!-- 招标代理登录 -->
                    <div class="role-grid-item" @click="handleLogin('agent')">
                        <div class="role-icon">
                            <img :src="dlImgPath" />
                        </div>
                        <div class="role-name">
                            <img :src="roleLoginTextsImg.agent" class="role-name-img" />
                        </div>
                    </div>
                    <!-- 评标系统 -->
                    <div class="role-grid-item" @click="handleLogin('evaluation')">
                        <div class="role-icon">
                            <img :src="zjImgPath" />
                        </div>
                        <div class="role-name">
                            <img :src="roleLoginTextsImg.evaluation" class="role-name-img" />
                        </div>
                    </div>
                </div>
               
            </div>
            <!-- <div class="login-logo">  
                    <img :src="loginLogoPath" />
                </div> -->
        </div>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import { XTXASynObject } from '@/api/ca/XTXASynObject'
export default {
    name: 'LoginPage',
    computed: {
        loginBgPath() {
            return this.$channelMaterial.getLoginBgPath()
        },
        roleBgStyle() {
            return this.$channelMaterial.getRoleLoginBgStyle()
        },
        // 投标人图片
        tbImgPath() {
            return this.$channelMaterial.tbLoginImg()
        },
        // 招标人图片
        zbImgPath() {
            return this.$channelMaterial.zbLoginImg()
        },
        // 招标代理图片
        dlImgPath() {
            return this.$channelMaterial.dLLoginImg()
        },
        zjImgPath() {
            return this.$channelMaterial.zjLoginImg()
        },
        roleLoginTexts() {
            return this.$channelMaterial.getRoleLoginTexts()
        },
        roleLoginTextsImg() {
            return this.$channelMaterial.getRoleLoginTextsImg()
        },
        loginLogoPath() {
            return this.$channelMaterial.getLoginLogoPath()
        },
    },

    mounted() {
    },
    methods: {
        handleLogin(type) {
            // 清除本地存储
            localStorage.clear()
            // 评标系统特殊处理
            if (type === 'evaluation') {
                window.open('/todayEvaluation', '_blank')
                return
            }
            // 获取对应的token
            const tokenKey = `token_${type}`
            const existingToken = Cookies.get(tokenKey)
            if (existingToken) {
                // 设置当前token
                Cookies.set('token', existingToken)
                // 路由映射配置
                const routeMap = {
                    'agent': '/agentHome',
                    'tenderee': '/agentHome',
                    'bidder': '/bidderHome',
                    'expert': '/expertHome'
                }
                console.log(tokenKey);

                //跳转到对应页面
                const targetRoute = routeMap[type] || '/home'
                this.$router.push(targetRoute)
            } else {
                this.$router.push('/useLogin?type=' + type)
            }
        }
    },
}
</script>

<style lang="less" scoped>
.login-page {
    position: relative;
    min-height: 100vh;
    width: 100%;
    overflow: hidden;
       //  右下角logo
       .login-logo {
            position: absolute;
            bottom: 1.04vw;
            right: 1.04vw;
            z-index: 10;
            img {
                width: 11.04vw;
                height: 2.92vw;
            }

        }

    .login-container {
        width: 100%;
        min-height: 100vh;
        position: relative;
        display: flex;
        flex-direction: column;
     
    }

    // 背景图片
    .background-image {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
    }

    // 中央内容区域
    .login-content {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 10.42vw;
        z-index: 10;
        gap: 3.65vw;

        .role-bg {
            position: relative;
            cursor: pointer;
            transition: all 0.3s ease;

            &:hover {
                transform: translateY(-0.52vw);
                box-shadow: 0 0.78vw 1.56vw rgba(0, 0, 0, 0.2);
            }

            img {
                width: 100%;
                height: 100%;
                transition: transform 0.3s ease;
                object-fit: contain;
            }

            .role-bg-text {
                position: absolute;
                bottom: 12%;
                font-family: PingFang SC, PingFang SC;
                left: 0;
                right: 0;
                text-align: center;
                font-weight: 400;
                font-size: 1.5vw;
                color: #000000;
                transition: color 0.3s ease;
            }

            .role-bg-text-img-container {
                margin-top: 0.52vw;
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;

                .role-bg-text-img {
                    width: 5.21vw;
                    height: 0.78vw;
                }
            }

        }
    }

    // 图片版本登录内容
    .login-content-img {
        position: absolute;
        top: 10.73vw;
        left: 8.59vw;
        z-index: 10;

        .login-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 5.73vw 6.25vw;

            .role-grid-item {
                width: 11.72vw;
                height: auto;
                border-radius: 0.42vw;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                transition: all 0.3s ease;
                .role-icon {
                    width: 11.72vw;
                    height: 11.72vw;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 0.99vw;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }
                }

                .role-name {
                    .role-name-img {
                        width: auto;
                        height: 0.78vw;
                    }
                }
            }
        }

    }

}

// 响应式适配：中等屏幕
@media (max-width: 1400px) {
    .login-page {
        .login-content {
            gap: 3vw;

            .role-bg {
                .role-bg-text {
                    font-size: 1.2vw;
                }
            }
        }
    }
}

// 响应式适配：小屏幕
@media (max-width: 1024px) {
    .login-page {
        .login-content {
            gap: 2vw;
            bottom: 5.21vw;

            .role-bg {
                .role-bg-text {
                    font-size: 1vw;
                }
            }
        }
    }
}

// 响应式适配：超小屏幕
@media (max-width: 768px) {
    .login-page {
        .login-content {
            flex-wrap: wrap;
            gap: 1.04vw;
            bottom: 2.6vw;

            .role-bg {
                min-width: 6.25vw;
                min-height: 6.25vw;

                .role-bg-text {
                    font-size: 0.62vw;
                }
            }
        }
    }
}</style>
